import type { GuidanceBlockKind } from './types'

interface GuidanceCopyEntry {
  /** Rótulo do controle que abre a explicação, no bloco. */
  door: string
  /** Título do sheet — e, por `MobileSheet`, seu nome acessível. */
  sheet: string
}

/**
 * Rótulo da porta e título do sheet, por bloco.
 *
 * Um dono só para os dois: `MobileSheet` deriva `aria-label` do próprio
 * `title`, então o texto do título é também o nome acessível do diálogo, e
 * espalhá-lo pelos call-sites faria o requisito de rótulo depender de quatro
 * arquivos concordarem.
 *
 * O rótulo nomeia o assunto que abre, nunca "Saiba mais" — `ACCESSIBILITY.md`
 * §1.6 pede que o controle diga o que faz estando parado.
 */
export const GUIDANCE_COPY: Record<GuidanceBlockKind, GuidanceCopyEntry> = {
  medals: {
    door: 'Como conquistar medalhas',
    sheet: 'Como conquistar medalhas'
  },
  ranking: {
    door: 'Como pontuar',
    sheet: 'Como pontuar'
  },
  missions: {
    door: 'Onde encontrar missões',
    sheet: 'Onde encontrar missões'
  }
}
